/**
 * 配置编译环境和线上环境之间的切换
 * 
 * baseUrl: 域名地址
 * baseImgPath: 图片存放地址
 * identityUrl: 验证服务器地址
 * identityConfig: 验证服务器oidc配置
 * apiUrl: API服务器地址
 * 
 */
import { WebStorageStateStore } from 'oidc-client';
import storage from '@/common/storage';

let baseUrl = '';
let baseImgPath = "";
let identityUrl = '';
let apiUrl = '';
let wezhanconfigUrl = '';

/**
 * isTestProductEnv
 * 是否是测试发布环境
 *
 * 发布正式环境时候需要设为false打包
 */

let isTestProductEnv = true;
let isRC = false;
let aliyifanghua = false;
let aliyifanghuaTestEnv = false;

if (process.env.NODE_ENV == 'development') {
  identityUrl = 'http://identity.test.wezhan.cn';
  apiUrl = 'http://localhost:5100';
  wezhanconfigUrl = 'http://localhost:5200';
} else {
  if (isTestProductEnv) {
    //测试、演示环境
    identityUrl = 'https://identity.test.wezhan.cn';
    apiUrl = 'https://bcapi.test.wezhan.cn';
    wezhanconfigUrl = 'http://api.scdext.wezhan.cn';
  } else if (isRC) {
    identityUrl = 'https://identity.rc.wezhan.cn';
    apiUrl = 'https://bcapi.rc.wezhan.cn';
    wezhanconfigUrl = 'http://api.scdext.wezhan.cn';
  }else {
    identityUrl = 'https://identity.wezhan.cn';
    apiUrl = 'https://bcapi.wezhan.cn';
    wezhanconfigUrl = 'https://scdext.wezhan.cn';
  }
}

if(aliyifanghua){
  identityUrl = 'https://newbcidentity.wanwang.xin';
  apiUrl = 'https://newbcapi.wanwang.xin';
  wezhanconfigUrl = 'https://scdext.wanwang.xin';
}
if(aliyifanghuaTestEnv){
  identityUrl = 'https://newbcidentity-test.wanwang.xin';
  apiUrl = 'https://newbcapi-test.wanwang.xin';
  wezhanconfigUrl = 'https://scdext-test.wanwang.xin';
}

console.log(identityUrl);



const host = window.location.origin;

const identityConfig = {
  authority: identityUrl,

  userStore: new WebStorageStateStore({ store: storage }),
  client_id: 'js',
  response_type: 'id_token token',
  scope: 'openid profile role jdy',

  redirect_uri: host + '/oidc/callback.html',
  silent_redirect_uri: host + '/oidc/silent.html',

  post_logout_redirect_uri: host + '/index.html',
  loadUserInfo: true,
  accessTokenExpiringNotificationTime: 5 * 60,
  automaticSilentRenew: true,
  filterProtocolClaims: true
};

export const environment = {
  baseUrl,
  baseImgPath,
  identityUrl,
  apiUrl,
  identityConfig,
  host,
  wezhanconfigUrl
}



// WEBPACK FOOTER //
// ./src/environments/environment.js